import React from 'react';
import NhiemVuTTXM from './NhiemVuTTXM.jsx';
import ConfirmDialog from './ConfirmDialog.jsx';
import moment from 'moment';
import { connect } from 'react-redux';
import { ShowIf } from 'components/utils';
import { DropDownChonPhongBanThuocCoQuan, DropDownChonCanBoGiaiQuyet, DropDownMulipleUse } from 'components/tt-forms';
import {TextArea} from 'components/tt-forms/common';
import { GiaiQuyetDonThu } from 'api';
import { Link } from 'react-router';
import {ContainerFileDinhKem} from 'components/upload';
import {
  getParams
} from 'modules/giai-quyet-don/subView/GetParams.jsx';
import {BlockGiaiQuyetDonInfo} from 'modules/giai-quyet-don/subView';

const vaiTro = 'CHUYEN_VIEN';
const loaiTepDinhKem = 'QUYET_DINH';
const loaiQuyTrinh = 'GIAI_QUYET_DON';

class TruongPhongNhanYeuCauDoiThoai extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      btnLoading: false,
      btnSaveLoading: false,
      openDialogTruongPhongGiaiQuyetDon: false,
      openDialogTruongPhongTTXM: false,
      onSave: false,
      id: this.props.id,
      role: this.props.role,
      loaiDon: this.props.loaiDon,
      validate: false,
      showAttach: false,
      focused:false,
      yKienGiaiQuyet: '',
      canBoGiaiQuyet: '',
      ngayHetHanGiaiQuyet: '',
      ngayHetHanKTDX: '',
      phongBanGiaiQuyet: '',
      taiLieuVanThu: [],
      taiLieuVanThuUpdate: [],
      taiLieuVanThuDelete: [],
      dataGiaiQuyetDon: [],
      dataFileDinhKem: {
        giaHan: [],
        data: []
      },
      dataTaiLieuVanThuDelete: [],
      thongTinGiaiQuyetDonId: this.props.thongTinGiaiQuyetDonId,
      coQuanQuanLyId: this.props.coQuanQuanLyId,
      coQuanQuanLyNguoiDung: this.props.coQuanQuanLyNguoiDung,
      nextState: 'TRUONG_PHONG_GIAO_VIEC_CAN_BO_LAP_DU_THAO',
      listTaiLieuVanThuGiaiQuyetDon: [],
      listTaiLieuVanThuGiaiQuyetDonView: [],
      dataNextStates: []
    }
  }

  componentDidMount() {
    this.getThongTinGiaiQuyetDon(this.state.thongTinGiaiQuyetDonId);
    if(this.props.dataNextStates) {
      let data = [...this.props.dataNextStates];
      let getGiaoPhongBan = data.find(state => state.type === "NHANLAPDUTHAO_GIAO_PHONG_CUNG_CAP");
      if (getGiaoPhongBan) {
        let phoPhong = {
          stateId: getGiaoPhongBan.stateId,
          ten: "Trưởng phòng giao việc phó phòng",
          tenVietTat: "Giao việc phó phòng",
          type: "TRUONG_PHONG_GIAO_VIEC_PHO_PHONG"
        };
        data.push(phoPhong);
      }
      let dataNextStateFilter = [];

      data.map(item => {
        let newItem = item;
        if (item.type == 'CAN_BO_CHUYEN_DU_THAO_VE_DON_VI_GIAI_QUYET') {
          newItem.tenVietTat = 'Tự giải quyết';
          newItem.ten = 'Trưởng phòng tự giải quyết';
        }
        dataNextStateFilter[dataNextStateFilter.length] = newItem;
      })
      this.setState({
        dataNextStates: dataNextStateFilter
      })
    }
  }

  componentDidUpdate(prevProps, prevState) {
    if(prevProps.truongPhongThuHoi == true) {
      if (this.select && prevState.focused == false) {
        this.setState({
          focused: true
        })
        this.select.focus();
      }
    }
  }

  componentWillReceiveProps(nextProps) {
    if(nextProps.dataNextStates) {
      let data = [...nextProps.dataNextStates];
      let dataNextStateFilter = [];
      let getGiaoPhongBan = data.find(state => state.type === "NHANLAPDUTHAO_GIAO_PHONG_CUNG_CAP");
      if (getGiaoPhongBan) {
        let phoPhong = {
          stateId: getGiaoPhongBan.stateId,
          ten: "Trưởng phòng giao việc phó phòng",
          tenVietTat: "Giao việc phó phòng",
          type: "TRUONG_PHONG_GIAO_VIEC_PHO_PHONG"
        };
        data.push(phoPhong);
      }
      data.map(item => {
        let newItem = item;
        if (item.type == 'CAN_BO_CHUYEN_DU_THAO_VE_DON_VI_GIAI_QUYET') {
          newItem.tenVietTat = 'Tự giải quyết';
          newItem.ten = 'Trưởng phòng tự giải quyết';
        }
        dataNextStateFilter[dataNextStateFilter.length] = newItem;
      })

      this.setState({
        dataNextStates: dataNextStateFilter
      })
    }
    this.setState({
      loaiDon: nextProps.loaiDon
    })
  }

  componentWillUnmount() {

  }

  onChange(name, e) {
    this.setState({
      [name]: e.target.value
    });
    if (name== 'nextState') {
      this.resetData();

    }
    this.props.handleChangeData();
  }

  resetData() {
    this.setState({
      canBoGiaiQuyet: '',
      yKienGiaiQuyet: '',
      noiDungKetLuanDuThao: '',
      showAttach: false
    }, ()=> {
      this.renderAttachFile();
    })
  }

  getThongTinGiaiQuyetDon(id) {
    if(typeof this.state.thongTinGiaiQuyetDonId != 'undefined') {
      let params = {
        id: id
      };
      GiaiQuyetDonThu.actions.getThongTinGiaiQuyetDon.request(params).then(res => {
        if(res.data) {
          this.setState({
            dataGiaiQuyetDon: res.data,
            phongBanGiaiQuyet: res.data.phongBanGiaiQuyetInfo && res.data.phongBanGiaiQuyetInfo.coQuanQuanLyId ? res.data.phongBanGiaiQuyetInfo.coQuanQuanLyId : '',
            canBoGiaiQuyet: res.data.canBoGiaiQuyetInfo ? res.data.canBoGiaiQuyetInfo.congChucId : '',
            yKienGiaiQuyet: res.data.yKienGiaiQuyet ? res.data.yKienGiaiQuyet : '',
            nextState: res.data.phoPhong ? "TRUONG_PHONG_GIAO_VIEC_PHO_PHONG" : (res.data.nextStateInfo ? res.data.nextStateInfo.type : (this.props.truongPhongThuHoi == true ? 'CAN_BO_CHUYEN_DU_THAO_VE_DON_VI_GIAI_QUYET' : '')),
            noiDungKetLuanDuThao: res.data.noiDungKetLuanDuThao ? res.data.noiDungKetLuanDuThao : '',
            ngayHetHanGiaiQuyet: res.data.ngayHetHanGiaiQuyet ? new Date(res.data.ngayHetHanGiaiQuyet) : '',
            ngayHetHanKTDX: res.data.ngayHetHanKTDX ? new Date(res.data.ngayHetHanKTDX): ''
          },()=> {
            this.checkOnlyState();
            this.renderAttachFile()
          });
        }
      });
    }
  }

  checkOnlyState() {
    if(this.props.dataNextStates.length == 1) {
      this.setState({
        nextState: this.props.dataNextStates[0].type
      }, ()=> {
        this.renderAttachFile()
      })
    }
  }

  onClickClose() {
    this.props.handleBack();
  }

  handleChangeDate(name, e) {
    if (e && e._d) {
      this.setState({
        [name]: e._d
      });
    } else {
      this.setState({
        [name]: e
      });
    }
    this.props.handleChangeData();
  }

  getParams() {
    let dataGiaiQuyetDon = this.state.dataGiaiQuyetDon;
    let params = getParams(dataGiaiQuyetDon, this.state.id);
    let selectedState = this.props.dataNextStates.filter(state => {
      return state.type == this.state.nextState
    });

    if(selectedState.length > 0) {
      params.nextState = {
        id: selectedState[0].stateId
      }
    } else {
      params.nextState = null
    }

    if(this.state.yKienGiaiQuyet) {
      params.yKienGiaiQuyet = this.state.yKienGiaiQuyet
    } else {
      params.yKienGiaiQuyet = ''
    }

    if(this.state.noiDungKetLuanDuThao) {
      params.noiDungKetLuanDuThao = this.state.noiDungKetLuanDuThao
    } else {
      params.noiDungKetLuanDuThao = ''
    }
    if (this.state.phongBanGiaiQuyet) {
      params.phongBanGiaiQuyet = {
        id: Number(this.state.phongBanGiaiQuyet)
      };
    }

    if(this.state.canBoGiaiQuyet) {
      params.canBoGiaiQuyet = {
        id: this.state.canBoGiaiQuyet
      }
    } else {
      params.canBoGiaiQuyet = null
    }

    if (this.state.nextState === "TRUONG_PHONG_GIAO_VIEC_PHO_PHONG") {
      params.phoPhong = true;
    } else {
      params.phoPhong = false;
    }
    return params;
  }

  handleSave(type){
    this.setState({
      onSave: true
    }, () => {

      this.setState({
        btnLoading: true,
        btnSaveLoading: true
      });
      let dataFileDinhKem = this.getListDataFileDinhKem();
      if (dataFileDinhKem.length > 0) {
        dataFileDinhKem.map((item, i) => {
          if (item.taiLieuVanThuId) {
            this.state.taiLieuVanThuUpdate[this.state.taiLieuVanThuUpdate.length] = {
              don: {
                id: Number(this.state.id)
              },
              id: item.taiLieuVanThuId,
              ten: item.ten,
              soQuyetDinh: item.soQuyetDinh,
              ngayQuyetDinh: item.ngayQuyetDinh ? moment(item.ngayQuyetDinh).add(7, 'hours').toISOString() : null,
              tenFile: item.tenFile,
              duongDan: item.duongDan,
              loaiTepDinhKem: item.loaiTepDinhKem,
              loaiQuyTrinh: item.loaiQuyTrinh,
              buocGiaiQuyet: item.buocGiaiQuyet,
              required: item.required,
              typeRequired: item.typeRequired ? item.typeRequired : ''
            };
          } else {
            this.state.taiLieuVanThu[this.state.taiLieuVanThu.length] = {
              don: {
                id: Number(this.state.id)
              },
              ten: item.ten,
              soQuyetDinh: item.soQuyetDinh,
              ngayQuyetDinh: item.ngayQuyetDinh ? moment(item.ngayQuyetDinh).add(7, 'hours').toISOString() : null,
              tenFile: item.tenFile,
              duongDan: item.duongDan,
              loaiTepDinhKem: loaiTepDinhKem,
              loaiQuyTrinh: loaiQuyTrinh,
              buocGiaiQuyet: item.phanLoaiQuyTrinh ? item.phanLoaiQuyTrinh : null,
              required: item.required,
              typeRequired: item.typeRequired ? item.typeRequired : ''
            };
          }
        });
      }

      if (this.state.nextState != 'CAN_BO_CHUYEN_DU_THAO_VE_DON_VI_GIAI_QUYET') {
        let dataDT = [...this.props.listTaiLieuVanThuGiaiQuyetDon];
        dataDT.filter(state => {
          return state.typeRequired == 'DT_KL_GQKN'
        }).map(item => {
          this.state.taiLieuVanThuDelete[this.state.taiLieuVanThuDelete.length] = {
            id: item.taiLieuVanThuId
          };
        });
      }

      if (this.state.dataTaiLieuVanThuDelete.length > 0) {
        this.state.dataTaiLieuVanThuDelete.map(item => {
          this.state.taiLieuVanThuDelete[this.state.taiLieuVanThuDelete.length] = {
            id: item
          };
        });
      }

      let params = this.getParams();

      this.postTaiLieuVanThu(this.state.taiLieuVanThu, () => {
        this.updateTaiLieuVanThu(this.state.taiLieuVanThuUpdate, () => {
          this.deleteTaiLieuVanThu(this.state.taiLieuVanThuDelete, () => {
            this.props.saveGiaiQuyetDon(params);
          });
        });
      });

    })
  }

  handleGiaiQuyetDon(type) {
    this.setState({
      onSave: false
    }, ()=> {
      if(this.validateSubmitForm()) {
        this.setState({
          isOpen: false,
          btnLoading: true
        });

        let dataFileDinhKem = this.getListDataFileDinhKem();

        if (dataFileDinhKem.length > 0) {
          dataFileDinhKem.map((item, i) => {
            if (item.taiLieuVanThuId) {
              this.state.taiLieuVanThuUpdate[this.state.taiLieuVanThuUpdate.length] = {
                don: {
                  id: Number(this.state.id)
                },
                id: item.taiLieuVanThuId,
                ten: item.ten,
                soQuyetDinh: item.soQuyetDinh,
                ngayQuyetDinh: item.ngayQuyetDinh ? moment(item.ngayQuyetDinh).add(7, 'hours').toISOString() : null,
                tenFile: item.tenFile,
                duongDan: item.duongDan,
                loaiTepDinhKem: item.loaiTepDinhKem,
                loaiQuyTrinh: item.loaiQuyTrinh,
                buocGiaiQuyet: item.buocGiaiQuyet,
                required: item.required,
                typeRequired: item.typeRequired ? item.typeRequired : ''
              };
            } else {
              this.state.taiLieuVanThu[this.state.taiLieuVanThu.length] = {
                don: {
                  id: Number(this.state.id)
                },
                ten: item.ten,
                soQuyetDinh: item.soQuyetDinh,
                ngayQuyetDinh: item.ngayQuyetDinh ? moment(item.ngayQuyetDinh).add(7, 'hours').toISOString() : null,
                tenFile: item.tenFile,
                duongDan: item.duongDan,
                loaiTepDinhKem: loaiTepDinhKem,
                loaiQuyTrinh: loaiQuyTrinh,
                buocGiaiQuyet: item.phanLoaiQuyTrinh ? item.phanLoaiQuyTrinh : null,
                required: item.required,
                typeRequired: item.typeRequired ? item.typeRequired : ''
              };
            }
          });
        }

        if (this.state.nextState != 'CAN_BO_CHUYEN_DU_THAO_VE_DON_VI_GIAI_QUYET') {
          let dataDT = [...this.props.listTaiLieuVanThuGiaiQuyetDon];
          dataDT.filter(state => {
            return state.typeRequired == 'DT_KL_GQKN'
          }).map(item => {
            this.state.taiLieuVanThuDelete[this.state.taiLieuVanThuDelete.length] = {
              id: item.taiLieuVanThuId
            };
          });
        }

        if (this.state.dataTaiLieuVanThuDelete.length > 0) {
          this.state.dataTaiLieuVanThuDelete.map(item => {
            this.state.taiLieuVanThuDelete[this.state.taiLieuVanThuDelete.length] = {
              id: item
            };
          });
        }

        let _params = this.getParams();
        let params = {};
        let msgName = '';
        if (type == 'giaoCanBo') {
          let selectedState = this.state.dataNextStates.find(state => state.type === this.state.nextState);
          if (this.state.nextState === "NHANLAPDUTHAO_GIAO_PHONG_CUNG_CAP") {
            params = {
              thongTinGiaiQuyetDon: {
                id: Number(this.state.thongTinGiaiQuyetDonId)
              },
              nextState: {
                id: Number(selectedState.stateId)
              },
              phongBanGiaiQuyet: {
                id: Number(this.state.phongBanGiaiQuyet)
              },
              yKienGiaiQuyet: this.state.yKienGiaiQuyet
            };
          } else if (this.state.nextState === 'TRUONG_PHONG_GIAO_VIEC_PHO_PHONG') {
            params = {
              canBoXuLyChiDinh: {
                id: Number(this.state.canBoGiaiQuyet)
              },
              thongTinGiaiQuyetDon: {
                id: Number(this.state.thongTinGiaiQuyetDonId)
              },
              nextState: {
                id: Number(selectedState.stateId)
              },
              phongBanGiaiQuyet : {
                id: Number(this.state.coQuanQuanLyNguoiDung.id)
              },
              phoPhong: true,
              yKienGiaiQuyet: this.state.yKienGiaiQuyet
            };
          } else {
            params = {
              canBoXuLyChiDinh: {
                id: Number(this.state.canBoGiaiQuyet)
              },
              thongTinGiaiQuyetDon: {
                id: Number(this.state.thongTinGiaiQuyetDonId)
              },
              nextState: {
                id: Number(selectedState.stateId)
              },
              yKienGiaiQuyet: this.state.yKienGiaiQuyet
            };
          }
          msgName = 'gqdGiaoViec';
        } else if (type == 'tuGiaiQuyet') {
          let selectedState = this.props.dataNextStates.filter(state => {
            return state.type == this.state.nextState
          });

          params = {
            thongTinGiaiQuyetDon: {
              id: Number(this.state.thongTinGiaiQuyetDonId)
            },
            nextState: {
              id: Number(selectedState[0].stateId)
            },
            yKienGiaiQuyet: this.state.noiDungKetLuanDuThao
          };
          msgName = 'gqdGuiDuThao';
        }
        this.postTaiLieuVanThu(this.state.taiLieuVanThu, () => {
          this.updateTaiLieuVanThu(this.state.taiLieuVanThuUpdate, () => {
            this.deleteTaiLieuVanThu(this.state.taiLieuVanThuDelete, () => {
              this.props.updateGiaiQuyetDon(_params, params, msgName);
            });
          });
        });
      }
    })
  }

  onFileChange(data, type) {
    if (type == 'GIA_HAN') {
      let dataFileDinhKem = this.state.dataFileDinhKem;

      dataFileDinhKem.giaHan = data

      this.setState ({
        dataFileDinhKem: dataFileDinhKem
      });
    } else {
      let dataFileDinhKem = this.state.dataFileDinhKem;

      dataFileDinhKem.data = data

      this.setState ({
        dataFileDinhKem: dataFileDinhKem
      });
    }
    this.props.handleChangeData();
  }

  onFileRemove(id, data, type) {
    this.setState({
      dataTaiLieuVanThuDelete: [
        ...this.state.dataTaiLieuVanThuDelete,
        id
      ]
    });

    if (type == 'GIA_HAN') {
      let dataFileDinhKem = this.state.dataFileDinhKem;

      dataFileDinhKem.giaHan = data

      this.setState ({
        dataFileDinhKem: dataFileDinhKem
      });
    } else {
      let dataFileDinhKem = this.state.dataFileDinhKem;

      dataFileDinhKem.data = data

      this.setState ({
        dataFileDinhKem: dataFileDinhKem
      });
    }
    this.props.handleChangeData();

  }

  getListDataFileDinhKem() {
    let dataFileDinhKem = []
    let Data = this.state.dataFileDinhKem;

    if (Data.data.length > 0) {
      Data.data.map(state => {
        dataFileDinhKem[dataFileDinhKem.length] = state
      })
    }

    if (Data.giaHan.length > 0 ) {
      Data.giaHan.map(state => {
        dataFileDinhKem[dataFileDinhKem.length] = state
      })
    }

    return dataFileDinhKem;
  }

  // Cap nhat tep dinh kem
  updateTaiLieuVanThu(fileList, callback) {
    if (fileList && fileList.length) {
      let params = {
        taiLieuVanThus: fileList
      };
      GiaiQuyetDonThu.actions.updateTaiLieuDinhKem.request('', params).then(res => {
        callback();
      }).catch(error => {
        if (error.response) {

        }
        callback();
      });
    } else {
      callback();
    }
  }

  // Them tep dinh kem
  postTaiLieuVanThu(fileList, callback) {
    if (fileList && fileList.length) {
      let params = {
        taiLieuVanThus: fileList
      };
      GiaiQuyetDonThu.actions.postTaiLieuDinhKem.request('', params).then(res => {
        callback();
      }).catch(error => {
        if (error.response) {

        }
        callback();
      });
    } else {
      callback();
    }
  }

  // Xoa tep dinh kem
  deleteTaiLieuVanThu(fileList, callback) {
    if (fileList && fileList.length) {
      let params = {
        taiLieuVanThus: fileList
      };
      GiaiQuyetDonThu.actions.deleteTaiLieuDinhKem.request('', params).then(res => {
        callback();
      }).catch(error => {
        if (error.response) {

        }
        callback();
      });
    } else {
      callback();
    }
  }

  validateSubmitForm() {
    let pass = true;
    this.props.validators['formTaoDon'].map(validator => {
      if(pass) {
        pass = validator.validate();
      } else {
        validator.validate();
      }
    });
    return pass;
  }

  openDialog(name) {
    if (this.validateSubmitForm()) {
      this.setState({
        openDialog: true
      })
    }
  }

  closeDialog() {
    this.setState({
      openDialog: false
    })
  }

  onSuccess(name) {
    this.setState({
      openDialog: false
    })
    this.handleGiaiQuyetDon('tuGiaiQuyet');
  }

  compareDate(firstDate, secondDate, type) {
    var firstTime = firstDate.getTime();
    var secondTime = secondDate.getTime()

    if (firstTime > secondTime || (firstTime == secondTime && type == 'show')) {
      return true
    } else {
      return false
    }
  }

  renderAttachFile() {
    let DataTaiLieuVanThu = [...this.props.listTaiLieuVanThuGiaiQuyetDon];
    let DataTaiLieuVanThuView = [...this.props.listTaiLieuVanThuGiaiQuyetDon];

    let listTaiLieuVanThuGiaiQuyetDon = DataTaiLieuVanThu.filter(state => {
      return this.compareDate(new Date(state.ngayTao), new Date(this.state.dataGiaiQuyetDon.ngayBatDauGiaoLapDuThao), 'action');
    })

    let listTaiLieuVanThuGiaiQuyetDonView = DataTaiLieuVanThuView.filter(state => {
      return this.compareDate(new Date(this.state.dataGiaiQuyetDon.ngayBatDauGiaoLapDuThao), new Date(state.ngayTao), 'show');
    })

    if (this.state.nextState == 'CAN_BO_CHUYEN_DU_THAO_VE_DON_VI_GIAI_QUYET') {
      let data = [...listTaiLieuVanThuGiaiQuyetDon];
      let dataCheck = data.filter(item => {
        return item.required && item.typeRequired == 'DT_KL_GQKN'
      })
      if (dataCheck.length > 0) {
        this.setState({
          listTaiLieuVanThuGiaiQuyetDon:listTaiLieuVanThuGiaiQuyetDon,
          listTaiLieuVanThuGiaiQuyetDonView: listTaiLieuVanThuGiaiQuyetDonView,
          showAttach: true
        })
      } else {
        let DT_KL = {
          ten: this.state.loaiDon === 'DON_TRANH_CHAP_DAT' ? 'Dự thảo quyết định về việc giải quyết' : 'Dự thảo quyết định về việc giải quyết khiếu nại',
          loaiTepDinhKem: '',
          soQuyetDinh: '',
          ngayQuyetDinh: '',
          tenFile: '',
          duongDan: '',
          progress: 0,
          required: true,
          typeRequired: 'DT_KL_GQKN',
          newFile: true
        }
        let TT_KL = {
          ten: this.state.loaiDon === 'DON_TRANH_CHAP_DAT' ? 'Tờ trình đề nghị ban hành QĐGQ' : 'Tờ trình đề nghị ban hành QĐGQ khiếu nại',
          loaiTepDinhKem: '',
          soQuyetDinh: '',
          ngayQuyetDinh: '',
          tenFile: '',
          duongDan: '',
          progress: 0,
          required: true,
          typeRequired: 'DT_KL_GQKN',
          newFile: true
        }
        this.setState({
          listTaiLieuVanThuGiaiQuyetDon: [
            ...this.state.listTaiLieuVanThuGiaiQuyetDon,
            TT_KL,
            DT_KL
          ],
          listTaiLieuVanThuGiaiQuyetDonView: listTaiLieuVanThuGiaiQuyetDonView,
          showAttach: true
        })
      }
    } else {
      let data = [...listTaiLieuVanThuGiaiQuyetDon];
      let dataCheck = data.filter(item => {
        return item.typeRequired != 'DT_KL_GQKN'
      })
      this.setState({
        listTaiLieuVanThuGiaiQuyetDon: dataCheck,
        listTaiLieuVanThuGiaiQuyetDonView: listTaiLieuVanThuGiaiQuyetDonView,
        showAttach: true
      })
    }
  }

  render() {

    return (
      <section className="wrap-block">
        <NhiemVuTTXM
          donViGiaoThamTraXacMinh={this.state.dataGiaiQuyetDon.donViGiaoThamTraXacMinhInfo}
          ngayBatDauTTXM={this.state.dataGiaiQuyetDon.ngayBatDauTTXM}
          yKienCuaDonViGiaoTTXM = {this.state.dataGiaiQuyetDon.yKienCuaDonViGiaoTTXM}
          ngayHetHanTTXM={this.state.dataGiaiQuyetDon.ngayHetHanTTXM}
          donInfo = {this.props.donInfo}
        />
        <div className="wrap-big-line pt5 pb15">
          <span className="big-border"></span>
        </div>
        <BlockGiaiQuyetDonInfo donInfo={this.props.donInfo} thongTinGQD={this.state.dataGiaiQuyetDon}/>

        <h2 className="title-14 mb15">Thông tin giải quyết</h2>
        <form className="form-action">
          <div className="row pl10 pr10">
            <DropDownMulipleUse
              onRef={select => (this.select = select)}
              className="col-25"
              donId={this.state.id}
              require
              isValid={this.state.validate}
              data={this.state.dataNextStates}
              bindValidator={this}
              selectedValue={this.state.nextState}
              label="Hướng giải quyết"
              name="huongGiaiQuyet"
              keyName='type'
              valueName='tenVietTat'
              onChange={this.onChange.bind(this, 'nextState')}/>
            <ShowIf condition={this.state.nextState === 'TRUONG_PHONG_GIAO_VIEC_PHO_PHONG'}>
              <DropDownChonCanBoGiaiQuyet
                selectedValue={this.state.canBoGiaiQuyet}
                require
                coQuanQuanLyId={this.state.coQuanQuanLyNguoiDung.id}
                vaiTro="PHO_PHONG"
                bindValidator={this}
                className="col-25"
                label="Chọn phó phòng"
                onChange={this.onChange.bind(this, 'canBoGiaiQuyet')}
                name="dropdownChonCanBoGiaiQuyet"
              />
              <TextArea value={this.state.yKienGiaiQuyet} className="areal-wrap col-100" label="Ý kiến xử lý" placeholder="Nhập ý kiến" onChange={this.onChange.bind(this, 'yKienGiaiQuyet')} name="textareaChonCanBoGiaiQuyet"/>
            </ShowIf>
            <ShowIf condition={this.state.nextState === 'NHANLAPDUTHAO_GIAO_PHONG_CUNG_CAP'}>
              <DropDownChonPhongBanThuocCoQuan
                require
                className="col-25"
                bindValidator={this}
                selectedValue={this.state.phongBanGiaiQuyet}
                isValid={this.props.validate}
                onChange={this.onChange.bind(this, 'phongBanGiaiQuyet')}
                name="dropdownChonPhongBanThuocCoQuan" />
                <TextArea value={this.state.yKienGiaiQuyet} className="areal-wrap col-100" label="Ý kiến xử lý" placeholder="Nhập ý kiến" onChange={this.onChange.bind(this, 'yKienGiaiQuyet')} name="textareaChonCanBoGiaiQuyet"/>
            </ShowIf>
            <ShowIf condition={this.state.nextState == 'TRUONG_PHONG_GIAO_VIEC_CAN_BO_LAP_DU_THAO'}>
              <DropDownChonCanBoGiaiQuyet
                selectedValue={this.state.canBoGiaiQuyet}
                require
                coQuanQuanLyId={this.state.coQuanQuanLyNguoiDung.id}
                vaiTro={vaiTro}
                bindValidator={this}
                className="col-25"
                label="Công chức giải quyết"
                onChange={this.onChange.bind(this, 'canBoGiaiQuyet')}
                name="dropdownChonCanBoGiaiQuyet"
              />
              <TextArea value={this.state.yKienGiaiQuyet} className="areal-wrap col-100" label="Ý kiến xử lý" placeholder="Nhập ý kiến" onChange={this.onChange.bind(this, 'yKienGiaiQuyet')} name="textareaChonCanBoGiaiQuyet"/>
            </ShowIf>
            <ShowIf condition={this.state.nextState == 'CAN_BO_CHUYEN_DU_THAO_VE_DON_VI_GIAI_QUYET'}>
              <TextArea value={this.state.noiDungKetLuanDuThao} className="areal-wrap col-100" label="Tóm tắt nội dung kết quả đối thoại" placeholder="Nhập..." onChange={this.onChange.bind(this, 'noiDungKetLuanDuThao')} name="textareaChonCanBoGiaiQuyet"/>
            </ShowIf>

            <ShowIf condition={this.state.showAttach}>
              <div className="col-100 pb5">
                <ContainerFileDinhKem onSave={this.state.onSave} label="Danh sách văn bản xử lý" bindValidator={this} dataShow={this.state.listTaiLieuVanThuGiaiQuyetDonView} data={this.state.listTaiLieuVanThuGiaiQuyetDon} onFileRemove={this.onFileRemove.bind(this)} onFileChange={this.onFileChange.bind(this)}/>
              </div>
            </ShowIf>
          </div>
          <div className="box-bottom">
            <Link className="btn-action btn-close action-todo" role="button" onClick={this.onClickClose.bind(this)}><span>Đóng</span></Link>
            <Link className={`btn-action btn-save action-todo ${this.state.btnLoading ? (this.state.btnSaveLoading ? 'btn-loading-inline' : 'btn-disable') : ''}`} onClick={this.handleSave.bind(this, 'truongPhongGiaiQuyetDon')}><span>Lưu tạm</span></Link>
            <ShowIf condition={this.state.nextState == 'TRUONG_PHONG_GIAO_VIEC_CAN_BO_LAP_DU_THAO' || this.state.nextState === "NHANLAPDUTHAO_GIAO_PHONG_CUNG_CAP" || this.state.nextState === "TRUONG_PHONG_GIAO_VIEC_PHO_PHONG"}>
              <Link style={{right: 0}} className={`btn-action btn-move right action-todo ${this.state.btnLoading ? (this.state.btnSaveLoading ? 'btn-disable' : 'btn-loading-inline') : ''}`} onClick={this.handleGiaiQuyetDon.bind(this, 'giaoCanBo')}><span>Giao việc</span></Link>
            </ShowIf>
            <ShowIf condition={this.state.nextState == 'CAN_BO_CHUYEN_DU_THAO_VE_DON_VI_GIAI_QUYET'}>
              <Link style={{right: 0}} className={`btn-action btn-move right action-todo ${this.state.btnLoading ? (this.state.btnSaveLoading ? 'btn-disable' : 'btn-loading-inline') : ''}`} onClick={this.openDialog.bind(this)}><span>Gửi dự thảo</span></Link>
            </ShowIf>
            <ConfirmDialog open={this.state.openDialog} onClose={this.closeDialog.bind(this)} onSuccess={this.onSuccess.bind(this)} title="Xác nhận" content={"Bạn có đồng ý chuyển cho " + (this.state.dataGiaiQuyetDon && this.state.dataGiaiQuyetDon.donViGiaoThamTraXacMinhInfo ? this.state.dataGiaiQuyetDon.donViGiaoThamTraXacMinhInfo.ten : '') +" dự thảo của đơn/vụ việc này không?"}/>
          </div>
        </form>
      </section>
    );
  }
}

TruongPhongNhanYeuCauDoiThoai.defaultProps = {
  dataKetLuanNoiDungKhieuNai: [],
  ketQuaGiaiQuyetDon: [],
  validators: {
    formTaoDon: []
  }
}

let bindStateToProps = state => {
  return {
    dataKetLuanNoiDungKhieuNai: state.duLieuHeThong.ketLuanNoiDungKhieuNai,
    ketQuaGiaiQuyetDon: state.duLieuHeThong.ketQuaGiaiQuyetDon
  }
}

export default connect(bindStateToProps)(TruongPhongNhanYeuCauDoiThoai)


// WEBPACK FOOTER //
// ./src/components/modules/giai-quyet-don/subView/TruongPhongNhanYeuCauDoiThoai.jsx